import { useMemo } from "react";
import { usePageContext } from "vike-react/usePageContext";

/**
 * Replacement for react-router's useSearchParams().
 * Returns a URLSearchParams object (read-only for SSR).
 */
export function useSearchParams(): [URLSearchParams] {
  const pageContext = usePageContext();
  const search =
    typeof window !== "undefined"
      ? window.location.search
      : (pageContext.urlParsed?.search
          ? "?" + new URLSearchParams(pageContext.urlParsed.search as any).toString()
          : "");
  return useMemo(() => [new URLSearchParams(search)], [search]);
}
